import React from "react";

interface LogoProps {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
  thickness?: number;
}

export function Logo({
  className,
  color = "#305CDE",
  width = 32,
  height = 32,
  thickness = 0,
}: LogoProps) {
  return (
    <div className={`flex items-center space-x-2 ${className || ""}`}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 139 146"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.53348 65.4042C3.36044 53.0064 2.0487 34.5662 17.9077 26.2951C22.4161 24.1148 27.2708 23.1743 31.9787 22.9553C32.478 21.9549 33.0157 20.97 33.5885 20.0035C39.938 8.88495 52.6415 -0.31285 66.7506 0.00815585C67.8966 0.0140971 69.0212 0.0695814 70.1661 0.171481C87.2427 1.895 98.2421 12.3131 106.24 25.3329C113.126 21.6464 123.373 24.0024 128.524 30.1428C128.863 30.5151 129.184 30.8894 129.506 31.2837C138.591 44.5143 133.863 58.2754 129.372 69.4754C128.914 70.4909 128.431 71.4863 127.907 72.4704C127.801 72.6664 127.665 72.8461 127.505 73C127.665 73.1539 127.801 73.3337 127.907 73.5296C128.431 74.5137 128.914 75.5091 129.372 76.5247C133.863 87.7246 138.591 101.486 129.506 114.716C129.184 115.111 128.863 115.485 128.524 115.857C123.373 121.998 113.126 124.354 106.24 120.667C98.2421 133.687 87.2427 144.105 70.1661 145.829C69.0212 145.93 67.8966 145.986 66.7506 145.992C52.6415 146.313 39.938 137.115 33.5885 125.997C33.0157 125.03 32.478 124.045 31.9787 123.045C27.2708 122.826 22.4161 121.885 17.9077 119.705C2.0487 111.434 3.36044 92.9936 5.53348 80.5958C6.01419 78.0256 6.60687 75.4889 7.28076 73C6.60687 70.5111 6.01419 67.9744 5.53348 65.4042ZM21.424 33.8537C24.958 32.2978 28.9902 31.6079 33.157 31.4999C63.149 32.6426 95.278 51.6119 120.243 70.3985H10.7695C10.6758 69.1992 10.4483 66.0246 10.3924 64.8302C9.74099 52.3663 11.555 37.8145 21.424 33.8537ZM33.157 114.5C63.4382 113.346 95.1351 94.802 120.243 75.8006H10.7695C10.605 77.5925 10.4759 79.3855 10.3924 81.1698C9.74099 93.6337 11.555 108.186 21.424 112.146C24.958 113.702 28.9902 114.392 33.157 114.5ZM66.7074 8.65958C67.6079 8.66426 68.4971 8.70401 69.4095 8.78207C95.0139 10.2437 105.805 38.7555 117.736 62.1761C95.1268 42.7573 68.9406 26.0941 37.5393 23.2374C45.306 14.4105 55.8677 8.45784 66.7074 8.65958ZM66.7074 137.34C67.6079 137.336 68.4971 137.296 69.4095 137.218C95.0139 135.756 105.805 107.245 117.736 83.8239C95.1268 103.243 68.9406 119.906 37.5393 122.763C45.306 131.59 55.8677 137.542 66.7074 137.34ZM122.863 36.7551C128.378 43.7338 127.275 56.9293 125.15 68.0943C120.263 56.833 115.602 42.0376 108.44 29.1089C114.274 29.3807 118.631 32.0535 122.159 35.9457C122.398 36.2076 122.628 36.4726 122.863 36.7551ZM122.863 109.245C128.378 102.266 127.275 89.0707 125.15 77.9057C120.263 89.167 115.602 103.962 108.44 116.891C114.274 116.619 118.631 113.946 122.159 110.054C122.398 109.792 122.628 109.527 122.863 109.245Z"
          fill={color}
          stroke={thickness > 0 ? color : "none"}
          strokeWidth={thickness}
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
